import React from 'react';
import AntPopover from 'antd/lib/popover';
import './style';

function Popover({ children, ...rest }) {
  return (
    <AntPopover {...rest}>
      {children}
    </AntPopover>
  );
}

Popover.defaultProps = AntPopover.defaultProps;
Popover.propTypes = AntPopover.propTypes;
export default Popover;
